import * as React from "react";
import styled, { css } from "styled-components";

const ErrorBoundaryView = styled.div`
  ${(props: { hidden?: boolean }) => css`
    display: ${props.hidden ? "none" : "block"};
  `};
`;

interface Props {
  hidden?: boolean;
}

const initialState = { hasError: false };
type State = Readonly<typeof initialState>;

export class ErrorBoundary extends React.Component<Props, State> {
  readonly state: State = initialState;

  constructor(props: Props) {
    super(props);
  }

  componentDidCatch(error: any, info: any) {
    // Display fallback UI
    this.setState({ hasError: true });
    console.error("Error occurred in component: ", error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorBoundaryView hidden={this.props.hidden}>
          <h1>An unexpected error occurred</h1>
          <div>Please try reloading the application or contact support</div>
        </ErrorBoundaryView>
      );
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./app/components/ErrorBoundary.tsx